// src/pages/AboutUsPage.jsx
import React, { useState, useEffect } from "react";
import { useLocale } from "../contexts/LocaleContext";
import { getAboutUsData } from "../api/apiService";
import PageBanner from "../components/common/PageBanner";
import RichTextRenderer from "../components/common/RichTextRenderer";

function AboutUsPage() {
  const { locale } = useLocale();
  const [aboutUsData, setAboutUsData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAboutUsContent = async () => {
      setLoading(true);
      setError(null);
      try {
        const data = await getAboutUsData(locale);
        setAboutUsData(data);
      } catch (err) {
        setError(err.message || "Failed to load content.");
        setAboutUsData(null);
      } finally {
        setLoading(false);
      }
    };

    fetchAboutUsContent();
  }, [locale]);

  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[calc(100vh-200px)]">
        <p className="text-xl text-gray-500">Loading...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto p-4 text-center">
        <p className="text-red-500 text-xl">Error: {error}</p>
      </div>
    );
  }

  if (!aboutUsData) {
    return (
      <div className="container mx-auto p-4 text-center">
        <p className="text-gray-700 text-xl">Content not available.</p>
      </div>
    );
  }

  const { banner, icon, content } = aboutUsData;
  const companyIconUrl =
    icon && icon.url ? `${icon.url}` : "/placeholder-logo.png"; // 提供一個預設 Logo

  return (
    <div>
      <PageBanner
        title={banner?.title}
        imageUrl={banner?.image?.url}
        titleColorIsWhite={banner?.titleColorIsWhite ?? true}
      />

      <div className="container mx-auto px-6 sm:px-10 lg:px-20 py-10 md:py-16 max-w-7xl">
        {" "}
        {icon && icon.url && (
          <div className="mb-8 md:mb-10 flex justify-start">
            <img
              src={companyIconUrl}
              alt={icon.alternativeText || icon.name || "Company Icon"}
              className="max-h-20 md:max-h-24 w-auto object-contain"
            />
          </div>
        )}
        <RichTextRenderer content={content} />
      </div>
    </div>
  );
}

export default AboutUsPage;
